import React from "react";
import elderlyMan from '../images/elderly-man.webp'
import logo from '../images/MyMusicNC_DANC_logo.png';
import mp3Button from '../images/mp3-button.svg';
import playlist from '../images/playlist.svg';

const GetStarted = () => {
  return (
    <div className="min-h-screen flex py-1 md:py-8 bg-gray-100">
      <div className="relative w-full h-full flex md:fixed md:inset-0 md:w-full md:h-full md:rounded-none md:shadow-none md:overflow-hidden z-50">
        <div className="hidden md:flex flex-col items-center justify-between w-1/2 py-0 px-0 relative h-full">
          <img
            src={elderlyMan}
            alt="elderlyMan"
            className="w-full h-full object-cover"
            style={{ imageRendering: "auto" }}
          />
        </div>
        <div className="flex-1 md:w-2/3 flex flex-col items-center justify-center py-12 px-4 sm:px-8 relative h-full bg-gray-100 overflow-y-auto min-h-screen md:min-h-0">
          <div className="w-full max-w-md mx-auto flex flex-col">
            <div className="flex justify-center md:justify-start mb-0">
              <img src={logo} alt="MP3" className="h-32 mx-auto md:mx-0" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-black mt-8 mb-8 opacity-70 text-center md:text-left">
              Are you or a loved one living at home with dementia?
            </h2>
            <p className="text-black/60 mb-8 text-center md:text-left">
              Anyone can use the My Music NC playlist builder to create a personalized playlist.
              Some North Carolina families may also qualify to receive <strong>a free Music & Memory at Home kit.</strong>
            </p>
            <a href="/onboard?mp3_player_is_required=true">
              <div className="flex items-center justify-between p-4 rounded-xl bg-white shadow-sm border border-gray-100 cursor-pointer hover:shadow-lg transition ">
                <div className="flex items-center space-x-4">
                  <div className="p-3 rounded-xl">
                    <img
                      src={mp3Button}
                      alt="MP3 Button"
                      className="h-24 w-auto"
                      style={{ filter: "invert(27%) sepia(99%) saturate(7476%) hue-rotate(203deg) brightness(97%) contrast(101%)" }}
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-blue-900">YES</div>
                    <div className="text-sm text-gray-500">The listener is a North Carolina resident with a diagnosis of dementia and lives at home.</div>
                  </div>
                </div>
              </div>
            </a>
            <a href="/onboard?mp3_player_is_required=false">
              <div className="flex items-center justify-between p-4 rounded-xl bg-white shadow-sm border border-gray-100 cursor-pointer hover:shadow-lg transition mt-5">
                <div className="flex items-center space-x-4">
                  <div className="p-3 rounded-xl">
                    <img
                      src={playlist}
                      alt="MP3 Button"
                      className="h-16 w-auto"
                      style={{ filter: "invert(27%) sepia(99%) saturate(7476%) hue-rotate(203deg) brightness(97%) contrast(101%)" }}
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-blue-900">NO</div>
                    <div className="text-sm text-gray-500"> I’m here to create a personalized playlist for someone living with dementia. </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;